<template>
  <gmap-marker
    v-on:click="clickStoreMarker(store)"
    :icon="storeIcon"
    :position="storePosition(store)"
    :animation="dropAnimation"
    >
    <gmap-info-window
      ref="infoWindow"
      :opened="store.openInfoWindow"
    >
      <div class="c-store-summary__title">
        <a class="u-h4 u-normal c-store-summary__link" :href="`/store/${store.post_name}`">{{ store.post_title }}</a>
      </div>
      <p class="u-margin-bottom-small">
        {{ store.store_address }}
        <br>
        {{ store.store_postcode }} {{ store.store_city }}
      </p>
      <p class="u-margin-bottom-tiny">
        <a class="c-button c-button--primary c-button--ghost c-button--stretch" :href="`tel:${store.store_phone}`" v-on:click="trackCall(store)">
          <span class="c-button__label">{{ store.store_phone }}</span>
        </a>
      </p>
    </gmap-info-window>
  </gmap-marker>
</template>

<script>
  import { sendEvent } from '../analytics'

  export default {
    props: [
      'store',
    ],
    data () {
      return {
        storeIcon: "https://maps.google.com/mapfiles/ms/icons/red-dot.png",
        dropAnimation: null,
      }
    },
    mounted () {
      this.$refs.infoWindow.$on('closeclick', () => {
        this.closeInfoWindow()
      })
      this.dropAnimation = google.maps.Animation.DROP
    },
    methods: {
      storePosition (store) {
        return {
          lat: store.store_latitude,
          lng: store.store_longitude,
        }
      },
      clickStoreMarker (store) {
        this.$store.dispatch('selectStore', store)
      },
      // This is because of a potential bug in vue2-google-maps:
      // when infoWindow is closed, opened stays at true.
      // We can't change it manually because the event fired has an empty payload
      // and we can't pass custom props with the store id to the infoWindow component.
      // We use the $store to simulate the case where no store is selected.
      // This will close all infoWindows but as we currently only have one opened
      // at the same time, it works.
      closeInfoWindow () {
        this.$store.dispatch('selectStore', null)
      },
      trackCall (store) {
        sendEvent("Store", "Call - map", store.ID)
      }
    },
  }
</script>
